export default "__VITE_ASSET__BDa4WKAL__"